import { render, staticRenderFns } from "./DefinitionTitle.vue?vue&type=template&id=a42711ac&scoped=true&"
import script from "./DefinitionTitle.vue?vue&type=script&lang=ts&"
export * from "./DefinitionTitle.vue?vue&type=script&lang=ts&"
import style0 from "./DefinitionTitle.vue?vue&type=style&index=0&id=a42711ac&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a42711ac",
  null
  
)

export default component.exports